import { render, staticRenderFns } from "./RegularOrdersAssignDialog.vue?vue&type=template&id=48d21240&scoped=true&"
import script from "./RegularOrdersAssignDialog.vue?vue&type=script&lang=ts&"
export * from "./RegularOrdersAssignDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RegularOrdersAssignDialog.vue?vue&type=style&index=0&id=48d21240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d21240",
  null
  
)

export default component.exports